import type { DummyFoods } from './dummyFoods'

export const lentils: DummyFoods = {
  Lentils: {
    Cooked: ['Lentils (cooked)'],
    Dry: ['Lentils (dry)'],
  },
}
